import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, DisplayS } from '@sorare/core/src/atoms/typography';
import { SeasonLeaderboardList } from '@sorare/core/src/components/rivals/Seasons/SeasonLeaderboardList';
import Avatar, { PictureAvatar } from '@sorare/core/src/components/user/Avatar';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { glossary, rivals } from '@sorare/core/src/lib/glossary';

import { ContentUnitLayout } from 'components/rivals/seasons/WelcomeToTheArena/ContentUnitLayout';
import { Description } from 'components/rivals/seasons/WelcomeToTheArena/Description';
import opponent from 'components/rivals/seasons/WelcomeToTheArena/assets/opponent.jpg';
import opponent2 from 'components/rivals/seasons/WelcomeToTheArena/assets/opponent2.jpg';
import opponent3 from 'components/rivals/seasons/WelcomeToTheArena/assets/opponent3.jpg';
import opponent4 from 'components/rivals/seasons/WelcomeToTheArena/assets/opponent4.jpg';

const Layout = styled(ContentUnitLayout)`
  position: relative;
  isolation: isolate;
  overflow: hidden;
  background: linear-gradient(
      rgba(var(--c-rgb-neutral-100), 0.54) 0%,
      rgba(var(--c-rgb-neutral-100), 0.54) 100%
    ),
    linear-gradient(to bottom, var(--c-rivals-friendlies) 0%, transparent 100%);
`;
const LeaderboardWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  z-index: -1;
`;

export const ClimbTheLeaderboard = () => {
  const { currentUser } = useCurrentUserContext();
  const { formatMessage } = useIntl();

  return (
    <Layout>
      <Vertical center>
        <DisplayS>
          <FormattedMessage
            id="WelcomeToTheArena.ClimbTheLeaderboard.title"
            defaultMessage="Fight for Promotion"
          />
        </DisplayS>
        <BodyM>
          <FormattedMessage
            id="WelcomeToTheArena.ClimbTheLeaderboard.subtitle"
            defaultMessage="Every week"
          />
        </BodyM>
      </Vertical>
      <Description>
        <FormattedMessage
          id="WelcomeToTheArena.ClimbTheLeaderboard.description"
          defaultMessage="Climb up the leaderboards with every win"
        />
      </Description>
      <LeaderboardWrapper>
        <SeasonLeaderboardList
          promotedRankings={[
            {
              id: '1',
              avatar: (
                <PictureAvatar
                  pictureUrl={opponent}
                  user={{ nickname: 'GoalMaster92' }}
                  rounded
                />
              ),
              cumulatedScoreDifference: 280,
              points: 36,
              ranking: 1,
              manager: {
                id: '1',
                user: {
                  slug: '1',
                  nickname: 'GoalMaster92',
                },
              },
              upcomingGamesCount: 0,
              liveGamesCount: 0,
              eligibleReward: {
                probabilisticBundleConfiguration: {
                  id: 'standard',
                  pictureUrl:
                    'https://frontend-assets.sorare.com/football/probabilistic_bundles/rivals-leaderboard-division-standard/picture.png',
                },
              },
            },
            {
              id: '2',
              avatar: (
                <PictureAvatar
                  pictureUrl={opponent2}
                  user={{ nickname: 'NetNinja22' }}
                  rounded
                />
              ),
              cumulatedScoreDifference: 250,
              points: 34,
              ranking: 2,
              manager: {
                id: '2',
                user: {
                  slug: '2',
                  nickname: 'NetNinja22',
                },
              },
              upcomingGamesCount: 0,
              liveGamesCount: 0,
              eligibleReward: null,
            },
            {
              id: '3',
              avatar: currentUser ? (
                <Avatar user={currentUser} rounded />
              ) : null,
              cumulatedScoreDifference: 230,
              points: 32,
              ranking: 3,
              manager: {
                id: '3',
                user: {
                  slug: '3',
                  nickname: formatMessage(glossary.you),
                },
              },
              upcomingGamesCount: 0,
              liveGamesCount: 0,
              eligibleReward: null,
            },
            {
              id: '4',
              avatar: (
                <PictureAvatar
                  pictureUrl={opponent3}
                  user={{ nickname: 'KickKing85' }}
                  rounded
                />
              ),
              cumulatedScoreDifference: 200,
              points: 31,
              ranking: 4,
              manager: {
                id: '4',
                user: {
                  slug: '4',
                  nickname: 'KickKing85',
                },
              },
              upcomingGamesCount: 0,
              liveGamesCount: 0,
              eligibleReward: null,
            },
            {
              id: '5',
              avatar: (
                <PictureAvatar
                  pictureUrl={opponent4}
                  user={{ nickname: 'ScoreSultan21' }}
                  rounded
                />
              ),
              cumulatedScoreDifference: 175,
              points: 30,
              ranking: 5,
              manager: {
                id: '5',
                user: {
                  slug: '5',
                  nickname: 'ScoreSultan21',
                },
              },
              upcomingGamesCount: 0,
              liveGamesCount: 0,
              eligibleReward: null,
            },
          ]}
          unrelegatedRankings={[]}
          relegatedRankings={[]}
          selectedUserSlug="3"
          promotedSectionTitle={formatMessage(rivals.divisionNumber, {
            number: 9,
          })}
        />
      </LeaderboardWrapper>
    </Layout>
  );
};
